var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocxIcon = function SvgDocxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DocxIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.667 10v13.333A3.334 3.334 0 0 0 50 26.667h13.334",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.667 70H23.334a6.667 6.667 0 0 1-6.667-6.667V16.667A6.667 6.667 0 0 1 23.334 10h23.333l16.667 16.667v36.666A6.667 6.667 0 0 1 56.667 70Z",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DocxIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.887 35.555 5.555 22.222 5.556-19.444 5.555 19.444 5.556-22.222",
    stroke: "#000",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DocxIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "DocxIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(23.333 30)",
    d: "M0 0h33.333v33.333H0z"
  })))));
};

export { SvgDocxIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzc2MV8zNDgwOCkiPgo8cGF0aCBkPSJNNDYuNjY3IDEwVjIzLjMzMzNDNDYuNjY3IDI0LjIxNzQgNDcuMDE4MiAyNS4wNjUyIDQ3LjY0MzMgMjUuNjkwNEM0OC4yNjg0IDI2LjMxNTUgNDkuMTE2MyAyNi42NjY3IDUwLjAwMDMgMjYuNjY2N0g2My4zMzM2IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01Ni42NjcgNzBIMjMuMzMzN0MyMS41NjU1IDcwIDE5Ljg2OTkgNjkuMjk3NiAxOC42MTk2IDY4LjA0NzRDMTcuMzY5NCA2Ni43OTcxIDE2LjY2NyA2NS4xMDE0IDE2LjY2NyA2My4zMzMzVjE2LjY2NjdDMTYuNjY3IDE0Ljg5ODYgMTcuMzY5NCAxMy4yMDI5IDE4LjYxOTYgMTEuOTUyNkMxOS44Njk5IDEwLjcwMjQgMjEuNTY1NSAxMCAyMy4zMzM3IDEwSDQ2LjY2N0w2My4zMzM3IDI2LjY2NjdWNjMuMzMzM0M2My4zMzM3IDY1LjEwMTQgNjIuNjMxMyA2Ni43OTcxIDYxLjM4MSA2OC4wNDc0QzYwLjEzMDggNjkuMjk3NiA1OC40MzUxIDcwIDU2LjY2NyA3MFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAxXzc2MV8zNDgwOCkiPgo8cGF0aCBkPSJNMjguODg2NyAzNS41NTUxTDM0LjQ0MjMgNTcuNzc3M0wzOS45OTc4IDM4LjMzMjhMNDUuNTUzNCA1Ny43NzczTDUxLjEwODkgMzUuNTU1MSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzYxXzM0ODA4Ij4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImNsaXAxXzc2MV8zNDgwOCI+CjxyZWN0IHdpZHRoPSIzMy4zMzMzIiBoZWlnaHQ9IjMzLjMzMzMiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMy4zMzMgMzApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";